import { useState } from "react";
import * as React from "react";
import Form from "../../../components/Form"; // Custom Form component
import { useMutation } from "@tanstack/react-query";
import { registerVendor } from "../../../utils/api/vendorRegisterApi";
import { toast } from "sonner";

interface Field {
  type?: "text" | "password" | "select";
  name: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<any>) => void;
  options?: { label: string; value: string }[];
}

const SignUp: React.FC = () => {
  // State for form data
  const [formData, setFormData] = useState({
    name: "",
    username: "",
    email: "",
    password: "",
    password_confirmation: "",
    role: "vendor",
  });

  // React Query mutation for registration
  const mutation = useMutation({
    mutationFn: registerVendor, // Pass the registerVendor function here
    onSuccess: (data: any) => {
      toast.success(data.message);
      // alert("Registration successful!");
      console.log("Response:", data);
    },
    onError: (error: any) => {
      const errors = error.response?.data?.errors;

      // Check if errors exist and format them
      const errorMessage = errors[0].msg;

      toast.error(errorMessage); // Display the formatted error
      console.error("Error Response:", error.response?.data || error.message); // Log for debugging
    },
  });

  // Handle input change
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    console.log(formData);
  };

  // Handle form submission
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // if (formData.password !== formData.password_confirmation) {
    //   alert("Passwords do not match!");
    //   return;
    // }
    mutation.mutate(formData); // Trigger the mutation
  };

  // Define the form fields
  const fields: Field[] = [
    {
      type: "text",
      name: "name",
      placeholder: "Enter your name",
      value: formData.name,
      onChange: handleChange,
    },
    {
      type: "text",
      name: "username",
      placeholder: "Enter your username",
      value: formData.username,
      onChange: handleChange,
    },
    {
      type: "text",
      name: "email",
      placeholder: "Enter your email",
      value: formData.email,
      onChange: handleChange,
    },
    {
      type: "password",
      name: "password",
      placeholder: "Enter your password",
      value: formData.password,
      onChange: handleChange,
    },
    {
      type: "password",
      name: "password_confirmation",
      placeholder: "Confirm your password",
      value: formData.password_confirmation,
      onChange: handleChange,
    },
  ];

  return (
    <div className="App mt-10 mb-14">
      <Form
        title="Registration Form"
        fields={fields}
        buttonLabel="Register"
        onSubmit={handleSubmit}
        className="max-w-md mx-auto shadow-lg p-6 bg-white rounded-md"
      />
    </div>
  );
};

export default SignUp;
